import React, { useState } from "react";
import WeekSelectionCalendar from "../../components/WeekSelectionCalendar";
import "./MealPlanCalendarSelectionPage.css";

const MealPlanCalendarSelectionPage = () => {
    const [hoveredWeekName, setHoveredWeekName] = useState(null);

    return (
        <div className="calendar-selection-page">
            <div className="calendar-selection-header">
                <h1>Select a Meal Plan Week</h1>
                <p>
                    Hover over a week to highlight it, then click to view the
                    meal plan
                </p>
                <div className="hovered-week-display">
                    {hoveredWeekName ? (
                        <span className="hovered-week-name">
                            Meal Plan: {hoveredWeekName}
                        </span>
                    ) : (
                        <span className="hovered-week-placeholder">&nbsp;</span>
                    )}
                </div>
            </div>
            <WeekSelectionCalendar onWeekHover={setHoveredWeekName} />
        </div>
    );
};

export default MealPlanCalendarSelectionPage;
